import { Media } from "@/services/bedrock";

export function validateMediasRequiremenst(medias?: Media[]): boolean {
  if (!medias) {
    return true;
  }

  return !medias.some(mediaWithErrors);
}

function mediaWithErrors(mediaElement: Media): boolean {
  const withRequirementErrors = mediaElement.errors ? Object.values(mediaElement.errors).some(error => error) : false;
  return (!mediaElement.validAspectRatio && mediaElement.validAspectRatio !== undefined) || withRequirementErrors;
}
